<template>
  <div>
    <vue-toastr ref="mytoast"></vue-toastr>
    <table class="table table-hover">
      <thead>
      <th style="width: 10px"></th>
      <th style="padding-left: 8px">Medien-Button</th>
      <th style="padding-left: 8px">Medien-Button gehört zu</th>
      <th style="padding-left: 8px">Vorschaubild</th>
      <th style="padding-left: 8px">Text vorhanden</th>
      <th style="padding-left: 8px">Text-Datei</th>
      <th style="padding-left: 8px">Inhalt-Typ</th>
      <th style="padding-left: 8px">Icon</th>
      <th></th>
      </thead>
      <tbody>
      <tr>
        <td></td>
        <td>
          <input type="text" id="media_type" v-model="data.media_type" class="form-control">
        </td>
        <td>
          <select class="form-control" id="belongs_to" v-model="data.belongs_to">
            <option value="">Keine Zuordnung</option>
            <option :value="key" v-for="(types, key) in belongs_to_options">{{ types }}</option>
          </select>
        </td>
        <td>
          <select class="form-control" id="belongs_to" v-model="data.bm_preview_images_id" @change="selectPreviewImage">
            <option value="">Kein Vorschaubild</option>
            <option :value="image.id" v-for="image in preview_images">{{ image.name }}</option>
            <option value="new">+ Vorschaubild hinzufügen</option>
          </select>
        </td>
        <td>
          <select class="form-control" id="text" v-model="data.got_text">
            <option value="0" selected>Nein</option>
            <option value="1">Ja</option>
          </select>
        </td>
        <td>
          <select class="form-control" name="" id="" v-model="data.media_type_text_id">
            <option :value="null">Keine</option>
            <option :value="media_type.id" v-for="media_type in text_media_types">{{media_type.media_type}}</option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="data.content_type">
            <option value="images" selected>Bilder</option>
            <option value="video">Videos</option>
            <option value="pdf">PDFs</option>
            <option value="word_files">Word-Dateien</option>
          </select>
        </td>
        <td><input type="file" @change="uploadImage" name="image" id="image" accept="image/*"></td>
        <td>
          <button type="button" id="0" class="btn btn-primary form-control" @click="add">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Hinzufügen
          </button>
        </td>
      </tr>
      </tbody>
      <draggable v-model="media_types" group="media_types" @start="drag=true" @end="updateList" tag="tbody"
                 handle=".fa">
        <tr v-for="(media_type, index) in media_types">
          <td><i class="fa fa-bars" aria-hidden="true" style="padding-top: 10px;cursor:grab;"></i></td>
          <td>
            <input type="text" class="form-control" v-model="media_type.media_type" :disabled="media_type.disabled">
          </td>
          <td>
            <select class="form-control" v-model="media_type.belongs_to" :disabled="media_type.disabled">
              <option value="">Keine Zuordnung</option>
              <option :value="key" v-for="(types, key) in belongs_to_options">{{ types }}</option>
            </select>
          </td>
          <td>
            <select class="form-control" id="belongs_to" v-model="media_type.bm_preview_images_id" @change="selectPreviewImage" :disabled="media_type.disabled">
              <option :value="null">Kein Vorschaubild</option>
              <option :value="image.id" v-for="image in preview_images">{{ image.name }}</option>
              <option value="new">+ Vorschaubild hinzufügen</option>
            </select>
          </td>
          <td>
            <select class="form-control" v-model="media_type.got_text" :disabled="media_type.disabled">
              <option value="0" selected>Nein</option>
              <option value="1">Ja</option>
            </select>
          </td>
          <td>
            <select class="form-control" :disabled="media_type.disabled" v-model="media_type.media_type_text_id">
              <option :value="null">Keine</option>
              <option :value="media_type.id" v-for="media_type in text_media_types">{{media_type.media_type}}</option>
            </select>
          </td>
          <td>
            <select class="form-control" v-model="media_type.content_type" :disabled="media_type.disabled">
              <option value="images">Bilder</option>
              <option value="video">Videos</option>
              <option value="pdf">PDFs</option>
              <option value="word_files">Word-Dateien</option>
            </select>
          </td>
          <td v-if="!media_type.icon || !media_type.disabled">
            <input type="file" @change="uploadImage" name="image" id="image" accept="image/*"
                   :disabled="media_type.disabled">
          </td>
          <td v-else>
            <img :src="media_type.icon" alt="" style="max-height: 40px; background: #000; padding: 3px">
          </td>
          <td>
            <div class="col-md-6" style="padding: 0">
              <button type="button" class="btn btn-primary form-control" @click="enable(media_type, index)"
                      v-if="media_type.disabled">
                <i class="fa fa-pencil edit"></i>
              </button>
              <button type="button" class="btn btn-primary form-control" @click="edit(media_type, index)" v-else>
                <i class="fa fa-check edit"></i>
              </button>
            </div>
            <div class="col-md-6" style="padding: 0 0 0 5px">
              <button type="button" class="btn btn-danger form-control" @click="deleteMediaType(media_type.id)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </draggable>
    </table>
    <modal ref="modal">
      <template #title>Vorschaubilder hinzufügen</template>
      <template #content>
        <div>
          <label for="">Titel</label>
          <input type="text" class="form-control" v-model="title_preview_image" placeholder="Hier eingeben...">
        </div>
        <br>
        <div>
        </div>
      </template>
      <template #footer>
        <button class="btn btn-primary" type="button" @click="savePreviewImage">Speichern</button>
        <button class="btn btn-secondary" type="button" @click="closeModal">Schließen</button>
      </template>
    </modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import VueToastr from "vue-toastr";
import Modal from "../../common/modal/Modal";

export default {
  name: 'FmuMediaTypes',
  components: {Modal, VueToastr, draggable},
  data() {
    return {
      media_types: [],
      preview_images: [],
      data: {
        bm_preview_images_id: '',
        media_type: '',
        belongs_to: '',
        got_text: 0,
        content_type: 'images',
        media_type_text_id: null
      },
      title_preview_image: '',
      text_media_types: [],
      belongs_to_options: {instagram: 'Instagram', facebook: 'Facebook', news_blog: 'News-Blog', mobileApp: 'App-News', magazine: 'WKZ-Trendblog'},
      image: '',
    }
  },
  methods: {
    updateList() {
      axios.post('/api/fmu/media_types/reorder', {
        media_types: this.media_types
      }).then(() => {
        this.$refs.mytoast.s("Neue Sortierung gespeichert", "Erfolgreich");
      }).catch(() => {
        this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
      })
    },
    add() {
      axios.post('/backend/fmu_media_types', {
        data: this.data,
        image: this.image
      }).then(() => {
        this.getAll();
        this.data.media_type = ''
        this.data.belongs_to = ''
        this.$refs.mytoast.s("Medien-Typ erfolgreich hinzugefügt", "Erfolgreich");
      }).catch(() => {
        this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
      })
    },
    enable(media_type, index) {
      media_type.disabled = false;
      this.$set(this.media_types, index, media_type)
    },
    edit(media_type, index) {

      let fd = new FormData()

      fd.set('image', this.image)
      fd.set('media_type', JSON.stringify(media_type))

      axios.post(`/backend/fmu_media_types/${media_type.id}`, fd,
          {
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(() => {
        this.$refs.mytoast.s("Medien-Typ erfolgreich bearbeitet", "Erfolgreich");
        this.getAll(index);
      }).catch(() => {
        this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
      })
    },
    deleteMediaType(id) {
      if (confirm('Bist du dir sicher?')) {
        axios.delete(`/backend/fmu_media_types/${id}`).then(() => {
          this.getAll();
          this.$refs.mytoast.s("Medien-Typ erfolgreich gelöscht", "Erfolgreich");
        }).catch(() => {
          this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
        })
      }
    },
    getAll(index) {
      axios.get('/backend/fmu_media_types').then((res) => {
        this.media_types = res.data
        this.media_types.map(item => item.disabled = true)

        this.text_media_types = res.data.filter(type => {
          return type.content_type === 'word_files'
        })
      })
    },
    getPreviewImages() {
      axios.get('/backend/bm_preview_images').then((res) => {
        this.preview_images = res.data
      })
    },
    uploadImage(e) {
      this.image = e.target.files[0]
    },
    selectPreviewImage(e) {
      let value = e.target.value;

      if (value === 'new') {
        this.data.bm_preview_images_id = ''

        let element = this.$refs.modal.$el
        $(element).modal('show')
      }
    },
    savePreviewImage() {
      axios.post('/backend/bm_preview_images', {
        name: this.title_preview_image
      }).then((res) => {
        this.$refs.mytoast.s("Vorschaubild erfolgreich erstellt", "Erfolgreich");
        this.title_preview_image = '';
        this.getPreviewImages();
        this.closeModal();
      })
    },
    closeModal() {
      let element = this.$refs.modal.$el
      $(element).modal('hide')
    }
  },
  mounted() {
    this.getAll();
    this.getPreviewImages();
  }
}
</script>

<style scoped>
.padding {
  padding: 5px 0
}
</style>
